import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import ItemInfo from 'features/private-views/purchase-commodity/ItemInfo'
import {
  setInitStatePurchase,
  setItemCount,
  setOrdersPayload,
} from 'features/private-views/purchase-commodity/purchaseCommoditySlice'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import SelectInputWithTestId from 'components/PMBSelect/SelectInputWithTestId'
import { MapPin } from 'react-feather'
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  FormGroup,
  Input,
  Label,
  Spinner,
} from 'reactstrap'
import { URL_PRODUCTION_UNIT } from 'utils/pathUrl'
import {
  fetchNearbyCities,
  matchLocationName,
  geocodeAddress,
} from 'utils/cityApi'
import { useGeolocation } from 'hooks/useGeolocation'
import {
  getListCity,
  getListDistrict,
  getListPostalCode,
  getListProvinces,
  getListSubdistrict,
} from '../../farmers-web/forms/formsAction'
import {
  addEditProductionUnit,
  addEditProductionUnitSelf,
} from './productionUnitAction'
import { P } from 'components'
import { useDebounce } from 'helpers'

const FormProductionUnit = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const dataState = location.state
  const [payload, setPayload] = useState({})
  const [loading, setLoading] = useState(false)

  const [debouncedAddressValue, setDebouncedAddressValue] = useState('')

  // Create a debounced function that updates the state used for geocoding
  const updateDebouncedAddress = useDebounce((val) => {
    setDebouncedAddressValue(val)
  }, 1000)

  const { enqueueSnackbar } = useSnackbar()

  // Get location lists from Redux (same as farmers form)
  const { provinces, cities, districts, subDistricts, postalCodes } =
    useSelector((state) => state.farmersForm)

  // Geolocation for auto-filling location fields
  const {
    coordinates,
    loading: geoLoading,
    error: geoError,
    getLocation,
  } = useGeolocation()
  const [loadingLocation, setLoadingLocation] = useState(false)
  const [loadingGeocode, setLoadingGeocode] = useState(false)

  // Disable states for cascading dropdowns
  const [disableCity, setDisableCity] = useState(true)
  const [disableDistrict, setDisableDistrict] = useState(true)
  const [disableSubDistrict, setDisableSubDistrict] = useState(true)

  const { orders, addItemCount } = useSelector(
    (state) => state.purchaseCommmodity,
  )
  const handleSubmit = async () => {
    setLoading(true)
    const obj = {
      items: orders?.item?.map((e) => {
        return {
          amount:
            typeof e?.amount === 'number'
              ? e?.amount
              : Number(
                  e?.amount
                    ?.replace?.(/\./g, '')
                    ?.replace?.(/,/g, '.')
                    ?.slice?.(0, 15),
                ),
          id: e?.itemId,
          unit: e?.unit?.value,
        }
      }),
      landName: payload?.landName,
      location: payload?.location,
      label: payload?.label,
      address: payload?.address || null,
      size: payload?.size ?? 0,
      province: payload?.province?.label || payload?.province || null,
      city: payload?.city?.label || payload?.city || null,
      district: payload?.district?.label || payload?.district || null,
      subDistrict: payload?.subDistrict?.label || payload?.subDistrict || null,
      latitude: payload?.latitude || null,
      longitude: payload?.longitude || null,
      ...(dataState?.isMember && {
        userId: dataState?.data?.data?.userId ?? payload?.userId,
      }),
      ...(dataState?.isEdit && {
        id: payload?.id ?? dataState?.data?.id,
      }),
    }
    const action = dataState?.isMember
      ? dispatch(addEditProductionUnit(obj))
      : dispatch(addEditProductionUnitSelf(obj))

    action
      .then((res) => {
        if (res?.error?.message) {
          throw res?.payload?.data?.message || res?.error?.message
        }
        navigate(
          !dataState?.isMember
            ? `${URL_PRODUCTION_UNIT}`
            : `/farmers/${dataState?.data?.data?.userId ?? payload?.userId}`,
        )
        dispatch(setInitStatePurchase())
        dataState?.isEdit
          ? enqueueSnackbar('Berhasil edit data unit produksi.', {
              variant: 'success',
            })
          : enqueueSnackbar('Berhasil tambah data unit produksi.', {
              variant: 'success',
            })
        setLoading(false)
      })
      .catch((err) => {
        enqueueSnackbar(
          err?.data?.meta?.message ||
            err?.data?.message ||
            err?.meta?.message ||
            err?.message ||
            String(err) ||
            'Terjadi kesalahan, silakan coba lagi.',
          {
            variant: 'error',
          },
        )

        setLoading(false)
      })
  }

  useEffect(() => {
    if (dataState?.isEdit) {
      const editData = dataState?.data
      setPayload(editData)

      // Initialize debounced address from edit data
      if (editData?.address) {
        setDebouncedAddressValue(editData.address)
      }

      dispatch(
        setOrdersPayload(
          editData?.landplottingitem?.map((e, i) => {
            return {
              orderItemId: i + 1,
              itemId: e?.itemId,
              amount: e?.amount,
              imageUrl: e?.linkFoto,
              nameItem: e?.nameItem,
              unit: {
                label: e?.unit,
                value: e?.unit,
              },
            }
          }),
        ),
      )
      dispatch(
        setItemCount(
          editData?.landplottingitem?.map((e, i) => {
            return i + 1
          }),
        ),
      )

      // Auto-fill location dropdowns from edit data
      if (editData?.province && provinces.length > 0) {
        setLoadingLocation(true)
        const matchingProvince = provinces.find((p) =>
          matchLocationName(editData.province, p.label),
        )

        if (matchingProvince) {
          setPayload((prev) => ({
            ...prev,
            province: matchingProvince,
          }))
          setDisableCity(false)

          // Load and match city
          dispatch(getListCity({ id: matchingProvince.id }))
            .then((cityAction) => {
              const cityList = cityAction.payload
              if (editData?.city && cityList) {
                const matchingCity = cityList.find((c) =>
                  matchLocationName(editData.city, c.label),
                )

                if (matchingCity) {
                  setPayload((prev) => ({
                    ...prev,
                    city: matchingCity,
                  }))
                  setDisableDistrict(false)

                  // Load and match district
                  dispatch(getListDistrict({ id: matchingCity.id }))
                    .then((districtAction) => {
                      const districtList = districtAction.payload
                      if (editData?.district && districtList) {
                        const matchingDistrict = districtList.find((d) =>
                          matchLocationName(editData.district, d.label),
                        )

                        if (matchingDistrict) {
                          setPayload((prev) => ({
                            ...prev,
                            district: matchingDistrict,
                          }))
                          setDisableSubDistrict(false)

                          // Load and match subdistrict
                          dispatch(
                            getListSubdistrict({ id: matchingDistrict.id }),
                          )
                            .then((subdistrictAction) => {
                              const subdistrictList = subdistrictAction.payload
                              if (editData?.subDistrict && subdistrictList) {
                                const matchingSubdistrict =
                                  subdistrictList.find((s) =>
                                    matchLocationName(
                                      editData.subDistrict,
                                      s.label,
                                    ),
                                  )

                                if (matchingSubdistrict) {
                                  setPayload((prev) => ({
                                    ...prev,
                                    subDistrict: matchingSubdistrict,
                                  }))
                                }
                              }
                              setLoadingLocation(false)
                            })
                            .catch(() => setLoadingLocation(false))
                        } else {
                          setLoadingLocation(false)
                        }
                      } else {
                        setLoadingLocation(false)
                      }
                    })
                    .catch(() => setLoadingLocation(false))
                } else {
                  setLoadingLocation(false)
                }
              } else {
                setLoadingLocation(false)
              }
            })
            .catch(() => setLoadingLocation(false))
        } else {
          setLoadingLocation(false)
        }
      }
    } else {
      setPayload({})
      dispatch(setInitStatePurchase())
    }
  }, [dataState?.data, provinces])

  // Load provinces on mount (same as farmers form)
  useEffect(() => {
    if (provinces.length < 1) {
      dispatch(getListProvinces())
    }
  }, [provinces])

  // Handle geolocation coordinates to auto-select location fields
  useEffect(() => {
    if (coordinates) {
      setLoadingLocation(true)
      fetchNearbyCities(coordinates.lat, coordinates.lng)
        .then((result) => {
          if (result && result.length > 0 && result[0].fullData) {
            const locationData = result[0].fullData

            // Auto-select province if it matches
            if (locationData.province && provinces.length > 0) {
              const matchingProvince = provinces.find((p) =>
                matchLocationName(locationData.province, p.label),
              )

              if (matchingProvince) {
                setPayload((prev) => ({
                  ...prev,
                  province: matchingProvince,
                  city: null,
                  district: null,
                  subDistrict: null,
                }))
                setDisableCity(false)

                // Load cities and auto-select city
                dispatch(getListCity({ id: matchingProvince.id })).then(
                  (cityAction) => {
                    const cityList = cityAction.payload
                    if (locationData.city && cityList) {
                      const matchingCity = cityList.find((c) =>
                        matchLocationName(locationData.city, c.label),
                      )

                      if (matchingCity) {
                        setPayload((prev) => ({
                          ...prev,
                          city: matchingCity,
                          district: null,
                          subDistrict: null,
                          location: matchingCity.label || '',
                        }))
                        setDisableDistrict(false)

                        // Load districts and auto-select district
                        dispatch(getListDistrict({ id: matchingCity.id })).then(
                          (districtAction) => {
                            const districtList = districtAction.payload
                            if (locationData.district && districtList) {
                              const matchingDistrict = districtList.find((d) =>
                                matchLocationName(
                                  locationData.district,
                                  d.label,
                                ),
                              )

                              if (matchingDistrict) {
                                setPayload((prev) => ({
                                  ...prev,
                                  district: matchingDistrict,
                                  subDistrict: null,
                                }))
                                setDisableSubDistrict(false)

                                // Load subdistricts and auto-select subdistrict
                                dispatch(
                                  getListSubdistrict({
                                    id: matchingDistrict.id,
                                  }),
                                ).then((subdistrictAction) => {
                                  const subdistrictList =
                                    subdistrictAction.payload
                                  if (
                                    locationData.subdistrict &&
                                    subdistrictList
                                  ) {
                                    const matchingSubdistrict =
                                      subdistrictList.find((s) =>
                                        matchLocationName(
                                          locationData.subdistrict,
                                          s.label,
                                        ),
                                      )

                                    if (matchingSubdistrict) {
                                      setPayload((prev) => ({
                                        ...prev,
                                        subDistrict: matchingSubdistrict,
                                      }))
                                    } else {
                                      enqueueSnackbar(
                                        `Kelurahan "${locationData.subdistrict}" tidak ditemukan dalam daftar`,
                                        { variant: 'warning' },
                                      )
                                    }
                                  }
                                })
                              } else {
                                enqueueSnackbar(
                                  `Kecamatan "${locationData.district}" tidak ditemukan dalam daftar`,
                                  { variant: 'warning' },
                                )
                              }
                            }
                          },
                        )
                      } else {
                        enqueueSnackbar(
                          `Kota "${locationData.city}" tidak ditemukan dalam daftar`,
                          { variant: 'warning' },
                        )
                      }
                    }
                  },
                )

                enqueueSnackbar(
                  `Provinsi terdeteksi: ${matchingProvince.label}`,
                  { variant: 'success' },
                )
              } else {
                enqueueSnackbar(
                  `Provinsi "${locationData.province}" tidak ditemukan dalam daftar`,
                  { variant: 'warning' },
                )
              }
            }
          }
          setLoadingLocation(false)
        })
        .catch((err) => {
          console.error('Error fetching location:', err)
          enqueueSnackbar('Gagal memuat data lokasi', { variant: 'error' })
          setLoadingLocation(false)
        })
    }
  }, [coordinates, provinces])

  // Geocode address when subDistrict is selected or address updates (debounced)
  useEffect(() => {
    if (
      payload?.subDistrict?.label &&
      payload?.district?.label &&
      payload?.city?.label &&
      payload?.province?.label
    ) {
      // Construct address string: "Address, Kelurahan, Kecamatan, Kota, Provinsi"
      // Use debounced address value
      const addressParts = [
        debouncedAddressValue,
        payload.subDistrict.label,
        payload.district.label,
        payload.city.label,
        payload.province.label,
      ].filter(Boolean)

      const fullAddress = addressParts.join(', ')

      // Call geocoding API
      setLoadingGeocode(true)
      geocodeAddress(fullAddress)
        .then((result) => {
          // Store lat/lng in payload
          setPayload((prev) => ({
            ...prev,
            latitude: result.lat,
            longitude: result.lng,
          }))

          // Only show snackbar if address actually provided logic to confirm it's not spam
          // But kept simple as requested
          // enqueueSnackbar(
          //   `Koordinat berhasil didapatkan: ${result.lat.toFixed(6)}, ${result.lng.toFixed(6)}`,
          //   { variant: 'success' },
          // )
        })
        .catch((err) => {
          console.error('Geocoding error:', err)
          // enqueueSnackbar('Gagal mendapatkan koordinat lokasi', {
          //   variant: 'warning',
          // })
        })
        .finally(() => {
          setLoadingGeocode(false)
        })
    }
  }, [
    payload?.subDistrict?.label,
    payload?.district?.label,
    payload?.city?.label,
    payload?.province?.label,
    debouncedAddressValue,
  ])

  return (
    <div className="w-100">
      <Container className="custom-container">
        <div className="d-flex align-items-start gap-2 pt-3">
          {dataState?.isMember ? (
            <BreadCrumbs
              breadCrumbParent2={dataState?.data?.data?.fullName}
              breadCrumbActive={
                dataState?.isEdit
                  ? 'Ubah Unit Produksi'
                  : 'Tambah Unit Produksi'
              }
              breadCrumbParent2Link={`/farmers/${dataState?.data?.data?.userId}`}
              breadCrumbParent={'Daftar Anggota'}
              breadCrumbParentLink={'/farmers'}
            />
          ) : (
            <BreadCrumbs
              breadCrumbParent2={'Unit Produksi'}
              breadCrumbActive={
                dataState?.isEdit
                  ? 'Ubah Unit Produksi'
                  : 'Tambah Unit Produksi'
              }
              breadCrumbParent2Link={URL_PRODUCTION_UNIT}
              breadCrumbParent={'Pengaturan'}
              breadCrumbParentLink={'/pengaturan-profile'}
            />
          )}
        </div>
        <Card className="shadow-sm border-0" data-testid="production-unit-modal-form">
          <CardBody>
            <CardTitle tag="h5" className="mb-3 fw-semibold">
              {dataState?.isEdit
                ? 'Edit Unit Produksi'
                : 'Tambah Unit Produksi'}
            </CardTitle>
            <FormGroup>
              <h6 className="fw-semibold">Informasi Wilayah</h6>
              <Label>Nama Wilayah</Label>
              <Input
                id="namaWilayah"
                name="namaWilayah"
                data-testid="production-unit-land-name-input"
                value={payload?.landName}
                className="mb-1"
                placeholder="Cth: Kebun Kopi Budi"
                onChange={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    landName: e?.target?.value,
                  }))
                }}
              />
            </FormGroup>

            {/* Location Fields with Geolocation */}
            <FormGroup>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Label className="mb-0">Provinsi</Label>
                <CustomButton
                  color="primary"
                  outline
                  size="sm"
                  testId="production-unit-geolocation-button"
                  onClick={getLocation}
                  disabled={geoLoading || loadingLocation}
                  style={{
                    padding: '0.25rem 0.5rem',
                  }}
                  title="Gunakan lokasi saya untuk mengisi otomatis"
                >
                  {geoLoading || loadingLocation ? (
                    <Spinner size="sm" />
                  ) : (
                    <>
                      <MapPin size={14} className="me-1" />
                      <span style={{ fontSize: '0.875rem' }}>
                        Gunakan Lokasi Saya
                      </span>
                    </>
                  )}
                </CustomButton>
              </div>
              <div data-testid="production-unit-province-select">
                <Select
                id="province"
                name="province"
                value={payload?.province}
                options={provinces}
                isLoading={provinces.length === 0 && !loadingLocation}
                isSearchable
                isClearable
                placeholder="Pilih provinsi..."
                noOptionsMessage={() => 'Tidak ada provinsi ditemukan'}
                components={{ Input: SelectInputWithTestId }}
                data-testid="production-unit-province-select"
                onChange={(selected) => {
                  setPayload((prev) => ({
                    ...prev,
                    province: selected,
                    city: null,
                    district: null,
                    subDistrict: null,
                  }))
                  if (selected) {
                    dispatch(getListCity({ id: selected.id }))
                    setDisableCity(false)
                    setDisableDistrict(true)
                    setDisableSubDistrict(true)
                  } else {
                    setDisableCity(true)
                    setDisableDistrict(true)
                    setDisableSubDistrict(true)
                  }
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '38px',
                    borderColor: '#d8dbe0',
                  }),
                }}
              />
              </div>
              {geoError && (
                <small className="text-danger mt-1 d-block">{geoError}</small>
              )}
            </FormGroup>

            <FormGroup>
              <Label>Kota</Label>
              <div data-testid="production-unit-city-select">
                <Select
                id="city"
                name="city"
                value={payload?.city}
                options={cities}
                isDisabled={disableCity}
                isSearchable
                isClearable
                placeholder={
                  payload?.province
                    ? 'Pilih kota...'
                    : 'Pilih provinsi terlebih dahulu'
                }
                components={{ Input: SelectInputWithTestId }}
                data-testid="production-unit-city-select"
                onChange={(selected) => {
                  setPayload((prev) => ({
                    ...prev,
                    city: selected,
                    district: null,
                    subDistrict: null,
                    location: selected?.label || '',
                  }))
                  if (selected) {
                    dispatch(getListDistrict({ id: selected.id }))
                    setDisableDistrict(false)
                    setDisableSubDistrict(true)
                  } else {
                    setDisableDistrict(true)
                    setDisableSubDistrict(true)
                  }
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '38px',
                    borderColor: '#d8dbe0',
                  }),
                }}
              />
              </div>
            </FormGroup>

            <FormGroup>
              <Label>Kecamatan</Label>
              <div data-testid="production-unit-district-select">
                <Select
                id="district"
                name="district"
                value={payload?.district}
                options={districts}
                isDisabled={disableDistrict}
                isSearchable
                isClearable
                placeholder={
                  payload?.city
                    ? 'Pilih kecamatan...'
                    : 'Pilih kota terlebih dahulu'
                }
                components={{ Input: SelectInputWithTestId }}
                data-testid="production-unit-district-select"
                onChange={(selected) => {
                  setPayload((prev) => ({
                    ...prev,
                    district: selected,
                    subDistrict: null,
                  }))
                  if (selected) {
                    dispatch(getListSubdistrict({ id: selected.id }))
                    setDisableSubDistrict(false)
                  } else {
                    setDisableSubDistrict(true)
                  }
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '38px',
                    borderColor: '#d8dbe0',
                  }),
                }}
              />
              </div>
            </FormGroup>

            <FormGroup>
              <Label>Kelurahan</Label>
              <div data-testid="production-unit-subdistrict-select">
                <Select
                id="subDistrict"
                name="subDistrict"
                value={payload?.subDistrict}
                options={subDistricts}
                isDisabled={disableSubDistrict}
                isSearchable
                isClearable
                placeholder={
                  payload?.district
                    ? 'Pilih kelurahan...'
                    : 'Pilih kecamatan terlebih dahulu'
                }
                components={{ Input: SelectInputWithTestId }}
                data-testid="production-unit-subdistrict-select"
                onChange={(selected) => {
                  setPayload((prev) => ({
                    ...prev,
                    subDistrict: selected,
                  }))
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '38px',
                    borderColor: '#d8dbe0',
                  }),
                }}
              />
              </div>
            </FormGroup>

            <FormGroup>
              <Label>Alamat</Label>
              <Input
                id="alamat"
                name="alamat"
                data-testid="production-unit-address-input"
                type="textarea"
                value={payload?.address || ''}
                className="mb-1"
                placeholder="Cth: Jl. Raya Kebun No. 123, RT 01/RW 02"
                rows={3}
                onChange={(e) => {
                  const val = e?.target?.value
                  setPayload((prev) => ({
                    ...prev,
                    address: val,
                  }))
                  updateDebouncedAddress(val)
                }}
              />
            </FormGroup>

            <FormGroup>
              <Label>Kode Wilayah (opsional)</Label>
              <Input
                id="kodeWilayah"
                name="kodeWilayah"
                data-testid="production-unit-label-input"
                value={payload?.label}
                className="mb-1"
                placeholder="Cth: 112"
                onChange={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    label: e?.target?.value,
                  }))
                }}
              />
            </FormGroup>

            <h6 className="fw-semibold pb-0 mb-0">Informasi Produksi</h6>
            <small className="text-muted">
              Tambahkan barang yang ada di wilayah ini
            </small>
            <div className="mt-2">
              <ItemInfo isProductionUnit />
            </div>
            <CustomButton
              className="mt-3"
              block
              color="primary"
              testId="production-unit-save-button"
              onClick={handleSubmit}
              disabled={
                loading ||
                !payload?.location ||
                !payload?.landName ||
                !payload?.province ||
                !payload?.city ||
                !payload?.district ||
                !payload?.subDistrict ||
                !payload?.address ||
                loadingGeocode
              }
            >
              Simpan Data
            </CustomButton>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default FormProductionUnit
